/**
 * @module events/types/touchCancel
 */

/**
 * @type {string}
 */
export default 'touchcancel'
